import React from 'react';
import useFetchDevFeatureFlagQuery from 'App/hooks/useFetchDevFeatureFlagQuery';
import PropTypes from 'prop-types';
import TherigyLoadingSpinner from 'App/components/TherigyLoadingSpinner';
import getFeatureFlagStatus from 'App/utils/getFeatureFlagStatus';

const propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]).isRequired,
    flagName: PropTypes.string.isRequired,
};

const defaultProps = {};

/**
 * Hide specific content behind a feature flag.
 * @param flagName
 * @param children
 * @return {*|JSX.Element|null}
 */
function FeatureFlag({ flagName, children }) {
    const { isLoading } = useFetchDevFeatureFlagQuery();

    if (isLoading) {
        return <TherigyLoadingSpinner />;
    }

    const showContent = getFeatureFlagStatus(flagName);

    if (showContent) {
        return children;
    }

    return null;
}

FeatureFlag.propTypes = propTypes;
FeatureFlag.defaultProps = defaultProps;

export default FeatureFlag;
